import { EntityProfileHeaderInfoItemBase } from '../../../../../Entity'
import { LISTING_PROFILE_HEADER_INFO_ITEMS_LOADING_LENGTH } from '../RentalPortalListingProfileHeaderInfoItems.constants'

function ListingProfileHeaderInfoItemsSkeleton({ className }) {
  return (
    <>
      {Array.from({
        length: LISTING_PROFILE_HEADER_INFO_ITEMS_LOADING_LENGTH,
      }).map((_, index) => (
        <EntityProfileHeaderInfoItemBase
          isLoading
          className={className}
          key={index}
        />
      ))}
    </>
  )
}

export default ListingProfileHeaderInfoItemsSkeleton
